import React from 'react';
import { GaugeContainer, GaugeFill } from './Gauge.styles';

const HalfGauge: React.FC = () => {
  return (
    <GaugeContainer>
      <GaugeFill width="50%" color="#FFBE55" />
    </GaugeContainer>
  );
};

export default HalfGauge;
